import React, { useRef, useState } from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import Keycloak from 'keycloak-js';
import HomePage from 'modules/HomePage';
// import { fetchToken, fetchUser, fetchUserByRole } from 'shared/services/Api';
// import { getCurrentUserRole } from 'shared/utils/SessionDataUtils';

const url = process.env.REACT_APP_AUTH_API_URL;
const clientId = process.env.REACT_APP_AUTH_CLIENT_ID;
const realm = process.env.REACT_APP_AUTH_REALM_URL;

const keycloak = new Keycloak({
    url: url,
    realm: realm,
    clientId: clientId,
});

const storeTokens = (keycloak) => {
    sessionStorage.setItem("keycloak_access_token", keycloak.token);
    sessionStorage.setItem("keycloak_refresh_token", keycloak.refreshToken);
    sessionStorage.setItem("keycloak_id_token", keycloak.idToken);
    sessionStorage.setItem("keycloak_token_claims", JSON.stringify(keycloak.tokenParsed));
    console.log("Tokens stored in sessionStorage.");
};

const clearSessionStorage = () => {

    sessionStorage.removeItem("keycloak_access_token");
    sessionStorage.removeItem("keycloak_refresh_token");
    sessionStorage.removeItem("keycloak_id_token");
    sessionStorage.removeItem("keycloak_token_claims");
    sessionStorage.removeItem("keycloak_user_profile");
    sessionStorage.removeItem("app_userprofile");
    sessionStorage.removeItem("app_role_userprofile");
    console.log("SessionStorage cleared on logout.");
};

export const fetchUserInfo = async (keycloak) => {
    try {
        // const response = await fetch(
        //     `${url}/realms/${realm}/protocol/openid-connect/userinfo`,
        //     {
        //         method: "GET",
        //         headers: {
        //             Authorization: `Bearer ${keycloak.token}`,
        //         },
        //     }
        // );
        const data = await keycloak.loadUserInfo(); // or however you fetch it
        sessionStorage.setItem("keycloak_user_profile", JSON.stringify(data));
        console.log("User profile stored in sessionStorage.", JSON.stringify(data));
    } catch (error) {
        console.error("Failed to fetch user info:", error);
    }
};

const KeycloakProviderWrapper = ({ children }) => {

    const [load, setLoad] = useState(false)
    const handleAuthEvent = async (keycloak) => {

        try {
            storeTokens(keycloak);
            // Optional: fetch basic Keycloak profile
            setLoad(true)
            console.log("Tokens and basic profile stored.");
        } catch (error) {
            console.error("Error during token setup:", error);
            keycloak.logout();

        }
    };


    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{
                onLoad: "check-sso",
                silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
                checkLoginIframe: true,
            }}
            onEvent={async (event, error) => {
                switch (event) {
                    case "onAuthSuccess":
                        console.log("Authentication successful.");
                        await handleAuthEvent(keycloak);

                        break;
                    case "onAuthRefreshSuccess":
                        console.log("Token successfully refreshed.");
                        storeTokens(keycloak);
                        break;
                    case "onAuthLogout":
                        console.log("User logged out.");
                        clearSessionStorage();
                        break;
                    case "onAuthError":
                    case "onAuthRefreshError":
                        console.error("Authentication or token refresh error.", error);
                        clearSessionStorage();
                        keycloak.logout();
                        break;
                    default:
                        break;
                }
            }}
        >
            {load ? children : <HomePage />}
        </ReactKeycloakProvider>
    );
};

export default KeycloakProviderWrapper;
